import React from "react"
import { DatoContentBaseProps } from "../../types"
import HeroInfoBlock from "@components/HeroInfoBlock"
import { ImageHotspotItem } from "@components/ImageHotspot"

interface DatoCmsComponentHeroInfoBlockProps extends DatoContentBaseProps {}

const stripHash = (value?: string) =>
  value?.startsWith("#") ? value.slice(1) : value

const plainTextFromStructured = (value?: { value?: any }) => {
  const document = value?.value?.document
  if (!document) return undefined
  let result = ""
  const walk = (node: any) => {
    if (!node) return
    if (node.type === "span" && typeof node.value === "string") {
      result += node.value
      return
    }
    if (Array.isArray(node.children)) {
      node.children.forEach(walk)
    }
  }
  walk(document)
  return result.trim() || undefined
}

const DatoCmsComponentHeroInfoBlock: React.FC<
  DatoCmsComponentHeroInfoBlockProps
> = ({
  subjectImage,
  headerImage,
  layout,
  headingText,
  headingTextColor,
  body,
  bodyTextColor,
  buttonText,
  buttonTextColor,
  buttonBgColor,
  buttonLink,
  bgImage,
  bgColor,
  hotspots,
}) => {
  const subjectImageSrc =
    subjectImage?.responsiveImage?.src || subjectImage?.url
  const headerImageSrc = headerImage?.responsiveImage?.src || headerImage?.url

  const bgImageSrc = bgImage?.responsiveImage?.src || bgImage?.url
  const mappedHotspots: ImageHotspotItem[] = (hotspots || []).map(
    (hotspot: any) => ({
      id: hotspot.id,
      x: hotspot.xAxis,
      y: hotspot.yAxis,
      label: hotspot.label,
      tileAlign: hotspot.tileAlign,
      previewImage: hotspot.previewImage?.url
        ? {
            src: hotspot.previewImage.url,
            alt: hotspot.imageAltText || hotspot.label,
          }
        : undefined,
    })
  )

  return (
    <HeroInfoBlock
      subjectImageSrc={subjectImageSrc}
      subjectImageAlt={subjectImage?.responsiveImage?.alt || headingText}
      hotspots={mappedHotspots}
      headerImage={headerImageSrc}
      layout={layout === "right" ? "right" : "left"}
      headingText={headingText}
      headingTextColor={stripHash(headingTextColor?.hex)}
      body={
        body ||
        "Bring your ideas to life. Tap into your creative side with TMI’s seat configurator."
      }
      bodyTextColor={stripHash(bodyTextColor?.hex)}
      buttonText={plainTextFromStructured(buttonText) || "Design Now"}
      buttonTextColor={stripHash(buttonTextColor?.hex)}
      buttonBgColor={stripHash(buttonBgColor?.hex)}
      buttonLink={buttonLink || "/seat-configurator"}
      bgImageSrc={bgImageSrc}
      bgColor={stripHash(bgColor?.hex)}
    />
  )
}

export default DatoCmsComponentHeroInfoBlock
